import React, { useState } from "react"
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap"

const ModalPage3 = props => {
  const { className } = props

  const [modal, setModal] = useState(false)

  const toggle = () => setModal(!modal)

  // console.log("modal", props.calendly)

  return (
    <div>
      {props.calendly ? (
        <a className="btn-global hvr-bounce-to-right mt-5" onClick={toggle}>
          <img className="img-fluid" alt="help" />
          Get Started
        </a>
      ) : (
        <a
          className="btn-global hvr-bounce-to-right mt-5"
          onClick={toggle}
          style={{ cursor: "pointer" }}
        >
          Get Started
        </a>
      )}

      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>Book an Appointment</ModalHeader>
        <ModalBody>
          <iframe
            title="Get Plan Preview"
            src="https://calendly.com/todd-001"
            width="100%"
            height="600"
            style={{ border: "none" }}
          />
        </ModalBody>
      </Modal>
    </div>
  )
}

export default ModalPage3
